import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppLiveText - ONE LIVE-REGION WRITE (fix campaign 2026-10-15): words set into a status element only when
// they differ, because a live region re-written with the same words is announced again. The error gate and
// the fault boundary live here once; each screen keeps its own one-line caller and its own diagnostic label.
// (`AppChatSettingsScreen.Text`, `AppTopBarRun.Put` - the two copies this replaces.)

/** A part whose `textContent` the write may set. */
export interface IAppLiveTextPart {
    textContent: string | null;
}

export class AppLiveText {
    /** The words set into `El` only when they differ - nothing rewritten that did not change. */
    public static Set = (El: IAppLiveTextPart | null, Words: string, Label: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (El !== null && El.textContent !== Words) { El.textContent = Words; }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, Label);
        }
    };
}
